import {getBackendAssetPath, getBackendAssetUrl} from '@shared/api';
import {createTranslationDict} from '@shared/helpers';
import {getLocalizedText} from '@shared/utils';
import {Category, SubCategory} from '../types';
import {
  AdminCategoryDetailOnBackend,
  AdminSubCategoryOnBackend,
  CategoryOnBackend,
  SubCategoryOnBackend,
} from './backendTypes';

export const mapCategoryFromBackend = ({
  id,
  name,
  description,
  logo_url,
  banner_url,
  order,
}: CategoryOnBackend): Category => ({
  id,
  name,
  description: description ?? '',
  logoUrl: getBackendAssetUrl(logo_url ?? ''),
  bannerUrl: getBackendAssetUrl(banner_url ?? ''),
  order: order ?? 0,
});

export const mapAdminCategoryDetailFromBackend = ({
  id,
  name,
  description,
  logo_url,
  banner_url,
  order,
}: AdminCategoryDetailOnBackend): Category => ({
  id,
  name: getLocalizedText(name),
  nameTranslations: createTranslationDict(name),
  description: description ? getLocalizedText(description) : '',
  descriptionTranslations: createTranslationDict(description),
  logoUrl: getBackendAssetUrl(logo_url ?? ''),
  bannerUrl: getBackendAssetUrl(banner_url ?? ''),
  order: order ?? 0,
});

export const mapSubCategoryFromBackend = (
  subCategory: SubCategoryOnBackend,
): SubCategory => ({
  id: subCategory.id ?? subCategory.slug ?? '',
  name: getLocalizedText(subCategory.name),
  slug: subCategory.slug ?? subCategory.id ?? '',
});

export const mapAdminSubCategoryFromBackend = ({
  id,
  slug,
  name,
  geos,
  logo_url,
  banner_url,
  published_events_count,
  active_events_count,
}: AdminSubCategoryOnBackend): SubCategory => ({
  id: slug,
  uuid: id ?? undefined,
  name: getLocalizedText(name),
  nameTranslations: createTranslationDict(name),
  slug,
  geos: (geos ?? []).filter((g): g is string => typeof g === 'string'),
  logoUrl: logo_url ? getBackendAssetUrl(logo_url) : undefined,
  bannerUrl: banner_url ? getBackendAssetUrl(banner_url) : undefined,
  publishedEventsCount: published_events_count ?? 0,
  activeEventsCount: active_events_count ?? 0,
});
